import React from 'react';
import './sample.css'
import {
    Users,
    Award,
    TrendingUp,
    Calendar,
    DollarSign,
    Megaphone,
    Star
} from 'lucide-react';

const MetaThankYou = () => {
    const executives = [
        {
            name: "Sarabjeet Singh",
            position: "President",
            icon: <Star size={20} />,
            description: "Vision and commitment to excellence, fostering innovation and collaboration"
        },
        {
            name: "Jaymes Kallar",
            position: "Vice President",
            icon: <TrendingUp size={20} />,
            description: "Strategic thinking and operational excellence in all initiatives"
        },
        {
            name: "Joan Therese Nufbale",
            position: "VP Treasury",
            icon: <DollarSign size={20} />,
            description: "Managed finances with precision and transparency"
        },
        {
            name: "Vladimir Rodriguez",
            position: "VP Admin",
            icon: <Users size={20} />,
            description: "Kept organization running seamlessly behind the scenes"
        },
        {
            name: "Hassan Hussein",
            position: "VP Events",
            icon: <Calendar size={20} />,
            description: "Exceptional event planning creating memorable experiences"
        },
        {
            name: "Shreyal Shah",
            position: "VP Marketing",
            icon: <Megaphone size={20} />,
            description: "Elevated brand presence and strategic communication"
        }
    ];

    return (
        <div className="meta-thankyou">
            <div className="container">
                <div className="meta-header">
                    <div className="meta-header-content">
                        <div className="meta-icon">
                            <Award size={40} />
                        </div>
                        <div className="meta-title-group">
                            <h1>A Heartfelt Thank You</h1>
                            <p>
                                To Our Outstanding 2024–2025 Executive Team from the <br />
                                Mechanical Engineering Technology Association (META)
                            </p>
                        </div>
                    </div>
                </div>

                <div className="message-card">
                    <p>
                        As we transition into a new chapter for META, we want to recognize and celebrate the exceptional leadership
                        of our outgoing executive team. Their dedication, vision, and hard work have not only strengthened our
                        organization but also created lasting impact.
                    </p>
                </div>

                <h2 className="section-title">Building an Amazing Foundation</h2>
                <br />
                <br />

                <div className="executive-grid">
                    {executives.map((exec, i) => (
                        <div className="executive-card" key={i}>
                            <div className="exec-header">
                                <div className="exec-icon">{exec.icon}</div>
                                <div>
                                    <div className="exec-name">{exec.name}</div>
                                    <div className="exec-position">{exec.position}</div>
                                </div>
                            </div>
                            <p className="exec-description">{exec.description}</p>
                        </div>
                    ))}
                </div>

                <div className="highlight-section">
                    <div className="highlight-card blue">
                        <div className="highlight-header">
                            <Calendar size={28} />
                            <h3>Industry Night Success</h3>
                        </div>
                        <p>
                            The Industry Night event brought together students, professionals, and academic leaders—creating valuable
                            networking and growth opportunities.
                        </p>
                    </div>

                    <div className="highlight-card indigo">
                        <div className="highlight-header">
                            <Users size={28} />
                            <h3>Amazing Connections</h3>
                        </div>
                        <p>
                            This team built bridges between students and industry, fostering mentorship and internship opportunities
                            for our members.
                        </p>
                    </div>
                </div>

                <div className="message-card">
                    <h2 className="section-title">A Strong Foundation for the Future</h2>
                    <br />
                    <br />
                    <br />
                    <p>
                        This team has left META in exceptional shape. With solid systems, strong industry relationships, and a
                        healthy culture, they’ve set the next team up for success.
                    </p>
                    <p>
                        Their legacy ensures META will continue serving the mechanical engineering community at the highest level.
                    </p>
                </div>

                <div className="closing-section">
                    <h2>Moving Forward with Gratitude</h2>
                    <p className="closing-message">
                        To Sarabjeet Singh, Jaymes Kallar, Joan Therese Nufbale, Vladimir Rodriguez, Hassan Hussein, and Shreyal
                        Shah! thank you for your tireless leadership and commitment to excellence.
                    </p>
                    <div className="closing-box">
                        <p>
                            Your contributions made a lasting impact. META moves forward with confidence, thanks to the strong
                            foundation you’ve built.
                        </p>
                    </div>
                    <p className="closing-credit">— The 2025-2026 META executive team and all our members</p>
                </div>
                <section className="president-message">
                    <div className="president-container">
                        <h2 className="section-title">A Message from Our Former President</h2>
                        <p className="president-intro">
                            Sarabjeet Singh shares his gratitude and reflections on the 2024–2025 executive team.
                        </p>

                        <blockquote className="president-quote">
                            <p>
                                As the former president of the Mechanical Engineering Technology Association (M.E.T.A) at
                                SAIT, I’m sitting down to write this with a full heart, wanting to share my deepest thanks to
                                the incredible executive team I had the privilege of working with in 2024-2025. Jaymes
                                Keller, Joan Nufable, Shreyal Shah, Vladimir Rodriguez, and Hassan Hussain—you all
                                poured so much into our club, and I’m truly humbled by your dedication. Your efforts made
                                M.E.T.A a place where students could grow, connect, and chase their dreams in
                                mechanical engineering. This isn’t just a formal thank-you; it’s a personal nod to the
                                amazing people you are and the impact you’ve had.
                            </p>

                            <p><strong>Jaymes Keller – Vice President</strong><br />
                                Jaymes, you were my right-hand person, always stepping up to keep things running
                                smoothly. From leading meetings to chasing down sponsorships, you brought so much
                                energy and heart to everything you did. Those sponsorships helped us pull off events that
                                gave our members real-world insights and opportunities. You were always there, making
                                sure we stayed true to our mission of supporting students. I can’t thank you enough for your
                                steady support and for being someone I could always count on.</p>

                            <p><strong>Joan Nufable – VP Finance</strong><br />
                                Joan, your care in managing our funds was something special. You made sure every dollar
went toward making our club better, whether it was for lunch-and-learn sessions or
supporting our competition teams. Landing those sponsorships was no small feat, and it
meant so much to our members. Your quiet strength and thoughtfulness kept us grounded,
and I’m so grateful for the way you handled everything with such grace.</p>

                            <p><strong>Shreyal Shah – VP Communications and Marketing</strong><br />
                               Shreyal, you had this incredible knack for getting the word out about M.E.T.A. You reached
out to other SAIT clubs, sparked ideas for collaborations, and hosted meetings that opened
new doors for us. Your passion for connecting people made our events and goals feel alive
and exciting. You helped our community grow stronger by sharing our story, and I’m so
thankful for your creativity and warmth.</p>

                            <p><strong>Vladimir Rodriguez – VP Administration</strong><br />
                                Vladimir, you were the glue that held us together. Keeping everyone on track and making
sure we all stuck to our responsibilities couldn’t have been easy, but you made it look
effortless. Your organizational skills kept our club humming, and your commitment to
supporting our members’ growth was inspiring. Thank you for your quiet dedication and for
always keeping us focused on what mattered most.</p>

                            <p><strong>Hassan Hussain – VP Events</strong><br />
                               Hassan, your creativity brought so much joy to our club. The meet-and-greet events you
dreamed up and the industry night we all planned together were highlights for so many of
our members. Those moments helped students connect with each other and with industry
pros, making our community feel like a family. Your enthusiasm was contagious, and I’m so
grateful for the way you brought people together.</p>

                            <p>
                                Together, you all made our industry night a reality, giving students a chance to meet
professionals and see what’s possible in mechanical engineering. You secured
sponsorships, built bridges with other clubs, and created events that made M.E.T.A a
welcoming, inspiring place. I’m in awe of how you each brought your unique strengths to
the table, always with kindness and a shared goal of helping our members thrive.
Looking back, I feel so lucky to have worked with such a caring and committed team. You
didn’t just uphold our club’s mission—you made it come alive in ways I’ll never forget. On
behalf of myself and everyone in M.E.T.A, thank you from the bottom of my heart. Your hard
work, passion, and care have left a lasting mark, and I know our members will carry that
forward.
                            </p>

                            <footer className="president-footer">
                                With all my gratitude,<br/>
                                — Sarabjeet Singh<br />
                                Former President, M.E.T.A
                            </footer>
                        </blockquote>
                    </div>
                </section>

            </div>
        </div>
    );
};

export default MetaThankYou;
